export function isMobile() {
  const regex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

export function isIntelled() {
  if (window.matchMedia("(display-mode: standalone)").matches) {
    return true;
  }
  return false;
}
